import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import Overlay from '../Overlay/Overlay';
import OverlayAnimation from '../OverlayAnimation/OverlayAnimation';
import StopPropagation from '../StopPropagation/StopPropagation';

const bem = new BEMHelper('OverlayWithToggle');

class OverlayWithToggle extends PureComponent {
    static propTypes = {
        open: PropTypes.bool,
        className: PropTypes.string,
        children: PropTypes.node,
        toggleComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
        toggleComponentProps: PropTypes.shape(),
    };

    static defaultProps = {
        toggleComponent: 'button',
    };

    state = {
        open: false,
    };

    handleClick = () => {
        this.setState((state) => ({ open: !state.open }));
    };

    render() {
        const showOverlay = this.state.open;
        const { toggleComponent: ToggleComponent, toggleComponentProps, children, className } = this.props;

        return (
            <StopPropagation className={bem(null, null, className)}>
                {!showOverlay && <ToggleComponent className={bem('toggle')} onClick={this.handleClick} open={this.state.open} {...toggleComponentProps} />}
                {showOverlay ? (
                    <OverlayAnimation>
                        <Overlay
                            key="overlay"
                            handleBodyClick={this.handleClick}
                            className={{
                                container: bem('container'),
                            }}
                            type="stickybag"
                        >
                            <ToggleComponent className={bem('toggle')} onClick={this.handleClick} open={this.state.open} {...toggleComponentProps} />
                            {children}
                        </Overlay>
                    </OverlayAnimation>
                ) : null}
            </StopPropagation>
        );
    }
}

export default OverlayWithToggle;
